import adminRoutes from "./Admin";
import instructorRoutes from "./Instructor";
import landingRoutes from "./landingPage";
/**
 * Combine and export the routes defined in the admin and user modules for better organization and easier usage.
 * @constant {Object} moduleRoutesMap
 */
const moduleRoutesMap = {
  admin: { ...adminRoutes },
  instructor: { ...instructorRoutes },
  landing : { ...landingRoutes },
};
export default moduleRoutesMap;
